/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'

const TestErrorLazyRouteImport = createFileRoute('/test-error')()
const AuthLayoutLazyRouteImport = createFileRoute('/_auth/_layout')()
const AuthSuperAdminRouteLazyRouteImport =
  createFileRoute('/_auth/super-admin')()
const AuthSuperAdminIndexLazyRouteImport = createFileRoute(
  '/_auth/super-admin/',
)()
const AuthSearchIndexLazyRouteImport = createFileRoute('/_auth/search/')()
const AuthCreditPoliciesIndexLazyRouteImport = createFileRoute(
  '/_auth/credit-policies/',
)()
const AuthCreditApplicationsIndexLazyRouteImport = createFileRoute(
  '/_auth/credit-applications/',
)()
const AuthLayoutIndexLazyRouteImport = createFileRoute('/_auth/_layout/')()
const AuthSuperAdminSettingsLazyRouteImport = createFileRoute(
  '/_auth/super-admin/settings',
)()
const AuthSuperAdminImportConfigurationsLazyRouteImport = createFileRoute(
  '/_auth/super-admin/import-configurations',
)()
const AuthSuperAdminImportLazyRouteImport = createFileRoute(
  '/_auth/super-admin/import',
)()
const AuthSuperAdminGroupsLazyRouteImport = createFileRoute(
  '/_auth/super-admin/groups',
)()
const AuthSuperAdminBillingLazyRouteImport = createFileRoute(
  '/_auth/super-admin/billing',
)()
const AuthSuperAdminApiKeysLazyRouteImport = createFileRoute(
  '/_auth/super-admin/api-keys',
)()
const AuthSuperAdminAgentsLazyRouteImport = createFileRoute(
  '/_auth/super-admin/agents',
)()
const AuthCreditPoliciesPolicyIdLazyRouteImport = createFileRoute(
  '/_auth/credit-policies/$policyId',
)()
const AuthCreditApplicationsSubmissionIdLazyRouteImport = createFileRoute(
  '/_auth/credit-applications/$submissionId',
)()
const AuthLayoutMetricsLazyRouteImport = createFileRoute(
  '/_auth/_layout/metrics',
)()
const AuthLayoutBenchmarksLazyRouteImport = createFileRoute(
  '/_auth/_layout/benchmarks',
)()
const AuthSearchQueryIndexLazyRouteImport = createFileRoute(
  '/_auth/search/$query/',
)()
const AuthAccountsLayoutAccountIdLazyRouteImport = createFileRoute(
  '/_auth/accounts/_layout/$accountId',
)()
const AuthAccountsLayoutAccountIdIndexLazyRouteImport = createFileRoute(
  '/_auth/accounts/_layout/$accountId/',
)()
const AuthAccountsLayoutAccountIdResearchAgentsLazyRouteImport =
  createFileRoute('/_auth/accounts/_layout/$accountId/research-agents')()
const AuthAccountsLayoutAccountIdPeopleLazyRouteImport = createFileRoute(
  '/_auth/accounts/_layout/$accountId/people',
)()
const AuthAccountsLayoutAccountIdNotificationsLazyRouteImport = createFileRoute(
  '/_auth/accounts/_layout/$accountId/notifications',
)()
const AuthAccountsLayoutAccountIdFinancialsLazyRouteImport = createFileRoute(
  '/_auth/accounts/_layout/$accountId/financials',
)()
const AuthAccountsLayoutAccountIdDetailsLazyRouteImport = createFileRoute(
  '/_auth/accounts/_layout/$accountId/details',
)()
const AuthAccountsLayoutAccountIdBenchmarksLazyRouteImport = createFileRoute(
  '/_auth/accounts/_layout/$accountId/benchmarks',
)()
const AuthAccountsLayoutAccountIdAuditLogLazyRouteImport = createFileRoute(
  '/_auth/accounts/_layout/$accountId/audit-log',
)()
const AuthAccountsLayoutAccountIdApplicationsLazyRouteImport = createFileRoute(
  '/_auth/accounts/_layout/$accountId/applications',
)()
const AuthAccountsLayoutAccountIdFinancialsIndexLazyRouteImport =
  createFileRoute('/_auth/accounts/_layout/$accountId/financials/')()
const AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRouteImport =
  createFileRoute(
    '/_auth/accounts/_layout/$accountId/financials/statement-edit/$statementId',
  )()

const TestErrorLazyRoute = TestErrorLazyRouteImport.update({
  id: '/test-error',
  path: '/test-error',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/test-error.lazy').then((d) => d.Route))
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLayoutLazyRoute = AuthLayoutLazyRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/_layout.lazy').then((d) => d.Route))
const AuthSuperAdminRouteLazyRoute = AuthSuperAdminRouteLazyRouteImport.update({
  id: '/super-admin',
  path: '/super-admin',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/super-admin/route.lazy').then((d) => d.Route),
)
const AuthSuperAdminIndexLazyRoute = AuthSuperAdminIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSuperAdminRouteLazyRoute,
} as any).lazy(() =>
  import('./routes/_auth/super-admin/index.lazy').then((d) => d.Route),
)
const AuthSearchIndexLazyRoute = AuthSearchIndexLazyRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./routes/_auth/search/index.lazy').then((d) => d.Route),
)
const AuthCreditPoliciesIndexLazyRoute =
  AuthCreditPoliciesIndexLazyRouteImport.update({
    id: '/credit-policies/',
    path: '/credit-policies/',
    getParentRoute: () => AuthRoute,
  } as any).lazy(() =>
    import('./routes/_auth/credit-policies/index.lazy').then((d) => d.Route),
  )
const AuthCreditApplicationsIndexLazyRoute =
  AuthCreditApplicationsIndexLazyRouteImport.update({
    id: '/credit-applications/',
    path: '/credit-applications/',
    getParentRoute: () => AuthRoute,
  } as any).lazy(() =>
    import('./routes/_auth/credit-applications/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLayoutIndexLazyRoute = AuthLayoutIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthLayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_auth/_layout.index.lazy').then((d) => d.Route),
)
const AuthSuperAdminSettingsLazyRoute =
  AuthSuperAdminSettingsLazyRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthSuperAdminRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/super-admin/settings.lazy').then((d) => d.Route),
  )
const AuthSuperAdminImportConfigurationsLazyRoute =
  AuthSuperAdminImportConfigurationsLazyRouteImport.update({
    id: '/import-configurations',
    path: '/import-configurations',
    getParentRoute: () => AuthSuperAdminRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/super-admin/import-configurations.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthSuperAdminImportLazyRoute =
  AuthSuperAdminImportLazyRouteImport.update({
    id: '/import',
    path: '/import',
    getParentRoute: () => AuthSuperAdminRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/super-admin/import.lazy').then((d) => d.Route),
  )
const AuthSuperAdminGroupsLazyRoute =
  AuthSuperAdminGroupsLazyRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => AuthSuperAdminRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/super-admin/groups.lazy').then((d) => d.Route),
  )
const AuthSuperAdminBillingLazyRoute =
  AuthSuperAdminBillingLazyRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthSuperAdminRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/super-admin/billing.lazy').then((d) => d.Route),
  )
const AuthSuperAdminApiKeysLazyRoute =
  AuthSuperAdminApiKeysLazyRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => AuthSuperAdminRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/super-admin/api-keys.lazy').then((d) => d.Route),
  )
const AuthSuperAdminAgentsLazyRoute =
  AuthSuperAdminAgentsLazyRouteImport.update({
    id: '/agents',
    path: '/agents',
    getParentRoute: () => AuthSuperAdminRouteLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/super-admin/agents.lazy').then((d) => d.Route),
  )
const AuthCreditPoliciesPolicyIdLazyRoute =
  AuthCreditPoliciesPolicyIdLazyRouteImport.update({
    id: '/credit-policies/$policyId',
    path: '/credit-policies/$policyId',
    getParentRoute: () => AuthRoute,
  } as any).lazy(() =>
    import('./routes/_auth/credit-policies/$policyId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthCreditApplicationsSubmissionIdLazyRoute =
  AuthCreditApplicationsSubmissionIdLazyRouteImport.update({
    id: '/credit-applications/$submissionId',
    path: '/credit-applications/$submissionId',
    getParentRoute: () => AuthRoute,
  } as any).lazy(() =>
    import('./routes/_auth/credit-applications/$submissionId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthLayoutMetricsLazyRoute = AuthLayoutMetricsLazyRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => AuthLayoutLazyRoute,
} as any).lazy(() =>
  import('./routes/_auth/_layout.metrics.lazy').then((d) => d.Route),
)
const AuthLayoutBenchmarksLazyRoute =
  AuthLayoutBenchmarksLazyRouteImport.update({
    id: '/benchmarks',
    path: '/benchmarks',
    getParentRoute: () => AuthLayoutLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/_layout.benchmarks.lazy').then((d) => d.Route),
  )
const AuthSearchQueryIndexLazyRoute =
  AuthSearchQueryIndexLazyRouteImport.update({
    id: '/search/$query/',
    path: '/search/$query/',
    getParentRoute: () => AuthRoute,
  } as any).lazy(() =>
    import('./routes/_auth/search/$query.index.lazy').then((d) => d.Route),
  )
const AuthAccountsLayoutAccountIdLazyRoute =
  AuthAccountsLayoutAccountIdLazyRouteImport.update({
    id: '/accounts/_layout/$accountId',
    path: '/accounts/$accountId',
    getParentRoute: () => AuthRoute,
  } as any).lazy(() =>
    import('./routes/_auth/accounts/_layout.$accountId.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAccountsLayoutAccountIdIndexLazyRoute =
  AuthAccountsLayoutAccountIdIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAccountsLayoutAccountIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/accounts/_layout.$accountId.index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAccountsLayoutAccountIdResearchAgentsLazyRoute =
  AuthAccountsLayoutAccountIdResearchAgentsLazyRouteImport.update({
    id: '/research-agents',
    path: '/research-agents',
    getParentRoute: () => AuthAccountsLayoutAccountIdLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/accounts/_layout.$accountId.research-agents.lazy'
    ).then((d) => d.Route),
  )
const AuthAccountsLayoutAccountIdPeopleLazyRoute =
  AuthAccountsLayoutAccountIdPeopleLazyRouteImport.update({
    id: '/people',
    path: '/people',
    getParentRoute: () => AuthAccountsLayoutAccountIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/accounts/_layout.$accountId.people.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAccountsLayoutAccountIdNotificationsLazyRoute =
  AuthAccountsLayoutAccountIdNotificationsLazyRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthAccountsLayoutAccountIdLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/accounts/_layout.$accountId.notifications.lazy'
    ).then((d) => d.Route),
  )
const AuthAccountsLayoutAccountIdFinancialsLazyRoute =
  AuthAccountsLayoutAccountIdFinancialsLazyRouteImport.update({
    id: '/financials',
    path: '/financials',
    getParentRoute: () => AuthAccountsLayoutAccountIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/accounts/_layout.$accountId.financials.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAccountsLayoutAccountIdDetailsLazyRoute =
  AuthAccountsLayoutAccountIdDetailsLazyRouteImport.update({
    id: '/details',
    path: '/details',
    getParentRoute: () => AuthAccountsLayoutAccountIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/accounts/_layout.$accountId.details.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAccountsLayoutAccountIdBenchmarksLazyRoute =
  AuthAccountsLayoutAccountIdBenchmarksLazyRouteImport.update({
    id: '/benchmarks',
    path: '/benchmarks',
    getParentRoute: () => AuthAccountsLayoutAccountIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/accounts/_layout.$accountId.benchmarks.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAccountsLayoutAccountIdAuditLogLazyRoute =
  AuthAccountsLayoutAccountIdAuditLogLazyRouteImport.update({
    id: '/audit-log',
    path: '/audit-log',
    getParentRoute: () => AuthAccountsLayoutAccountIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/accounts/_layout.$accountId.audit-log.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAccountsLayoutAccountIdApplicationsLazyRoute =
  AuthAccountsLayoutAccountIdApplicationsLazyRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => AuthAccountsLayoutAccountIdLazyRoute,
  } as any).lazy(() =>
    import('./routes/_auth/accounts/_layout.$accountId.applications.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthAccountsLayoutAccountIdFinancialsIndexLazyRoute =
  AuthAccountsLayoutAccountIdFinancialsIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthAccountsLayoutAccountIdFinancialsLazyRoute,
  } as any).lazy(() =>
    import(
      './routes/_auth/accounts/_layout.$accountId.financials.index.lazy'
    ).then((d) => d.Route),
  )
const AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRoute =
  AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRouteImport.update(
    {
      id: '/statement-edit/$statementId',
      path: '/statement-edit/$statementId',
      getParentRoute: () => AuthAccountsLayoutAccountIdFinancialsLazyRoute,
    } as any,
  ).lazy(() =>
    import(
      './routes/_auth/accounts/_layout.$accountId.financials.statement-edit.$statementId.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/test-error': typeof TestErrorLazyRoute
  '/super-admin': typeof AuthSuperAdminRouteLazyRouteWithChildren
  '/benchmarks': typeof AuthLayoutBenchmarksLazyRoute
  '/metrics': typeof AuthLayoutMetricsLazyRoute
  '/credit-applications/$submissionId': typeof AuthCreditApplicationsSubmissionIdLazyRoute
  '/credit-policies/$policyId': typeof AuthCreditPoliciesPolicyIdLazyRoute
  '/super-admin/agents': typeof AuthSuperAdminAgentsLazyRoute
  '/super-admin/api-keys': typeof AuthSuperAdminApiKeysLazyRoute
  '/super-admin/billing': typeof AuthSuperAdminBillingLazyRoute
  '/super-admin/groups': typeof AuthSuperAdminGroupsLazyRoute
  '/super-admin/import': typeof AuthSuperAdminImportLazyRoute
  '/super-admin/import-configurations': typeof AuthSuperAdminImportConfigurationsLazyRoute
  '/super-admin/settings': typeof AuthSuperAdminSettingsLazyRoute
  '/': typeof AuthLayoutIndexLazyRoute
  '/credit-applications': typeof AuthCreditApplicationsIndexLazyRoute
  '/credit-policies': typeof AuthCreditPoliciesIndexLazyRoute
  '/search': typeof AuthSearchIndexLazyRoute
  '/super-admin/': typeof AuthSuperAdminIndexLazyRoute
  '/accounts/$accountId': typeof AuthAccountsLayoutAccountIdLazyRouteWithChildren
  '/search/$query': typeof AuthSearchQueryIndexLazyRoute
  '/accounts/$accountId/applications': typeof AuthAccountsLayoutAccountIdApplicationsLazyRoute
  '/accounts/$accountId/audit-log': typeof AuthAccountsLayoutAccountIdAuditLogLazyRoute
  '/accounts/$accountId/benchmarks': typeof AuthAccountsLayoutAccountIdBenchmarksLazyRoute
  '/accounts/$accountId/details': typeof AuthAccountsLayoutAccountIdDetailsLazyRoute
  '/accounts/$accountId/financials': typeof AuthAccountsLayoutAccountIdFinancialsLazyRouteWithChildren
  '/accounts/$accountId/notifications': typeof AuthAccountsLayoutAccountIdNotificationsLazyRoute
  '/accounts/$accountId/people': typeof AuthAccountsLayoutAccountIdPeopleLazyRoute
  '/accounts/$accountId/research-agents': typeof AuthAccountsLayoutAccountIdResearchAgentsLazyRoute
  '/accounts/$accountId/': typeof AuthAccountsLayoutAccountIdIndexLazyRoute
  '/accounts/$accountId/financials/': typeof AuthAccountsLayoutAccountIdFinancialsIndexLazyRoute
  '/accounts/$accountId/financials/statement-edit/$statementId': typeof AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRoute
}
export interface FileRoutesByTo {
  '/test-error': typeof TestErrorLazyRoute
  '/benchmarks': typeof AuthLayoutBenchmarksLazyRoute
  '/metrics': typeof AuthLayoutMetricsLazyRoute
  '/credit-applications/$submissionId': typeof AuthCreditApplicationsSubmissionIdLazyRoute
  '/credit-policies/$policyId': typeof AuthCreditPoliciesPolicyIdLazyRoute
  '/super-admin/agents': typeof AuthSuperAdminAgentsLazyRoute
  '/super-admin/api-keys': typeof AuthSuperAdminApiKeysLazyRoute
  '/super-admin/billing': typeof AuthSuperAdminBillingLazyRoute
  '/super-admin/groups': typeof AuthSuperAdminGroupsLazyRoute
  '/super-admin/import': typeof AuthSuperAdminImportLazyRoute
  '/super-admin/import-configurations': typeof AuthSuperAdminImportConfigurationsLazyRoute
  '/super-admin/settings': typeof AuthSuperAdminSettingsLazyRoute
  '/': typeof AuthLayoutIndexLazyRoute
  '/credit-applications': typeof AuthCreditApplicationsIndexLazyRoute
  '/credit-policies': typeof AuthCreditPoliciesIndexLazyRoute
  '/search': typeof AuthSearchIndexLazyRoute
  '/super-admin': typeof AuthSuperAdminIndexLazyRoute
  '/search/$query': typeof AuthSearchQueryIndexLazyRoute
  '/accounts/$accountId/applications': typeof AuthAccountsLayoutAccountIdApplicationsLazyRoute
  '/accounts/$accountId/audit-log': typeof AuthAccountsLayoutAccountIdAuditLogLazyRoute
  '/accounts/$accountId/benchmarks': typeof AuthAccountsLayoutAccountIdBenchmarksLazyRoute
  '/accounts/$accountId/details': typeof AuthAccountsLayoutAccountIdDetailsLazyRoute
  '/accounts/$accountId/notifications': typeof AuthAccountsLayoutAccountIdNotificationsLazyRoute
  '/accounts/$accountId/people': typeof AuthAccountsLayoutAccountIdPeopleLazyRoute
  '/accounts/$accountId/research-agents': typeof AuthAccountsLayoutAccountIdResearchAgentsLazyRoute
  '/accounts/$accountId': typeof AuthAccountsLayoutAccountIdIndexLazyRoute
  '/accounts/$accountId/financials': typeof AuthAccountsLayoutAccountIdFinancialsIndexLazyRoute
  '/accounts/$accountId/financials/statement-edit/$statementId': typeof AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/test-error': typeof TestErrorLazyRoute
  '/_auth/super-admin': typeof AuthSuperAdminRouteLazyRouteWithChildren
  '/_auth/_layout': typeof AuthLayoutLazyRouteWithChildren
  '/_auth/_layout/benchmarks': typeof AuthLayoutBenchmarksLazyRoute
  '/_auth/_layout/metrics': typeof AuthLayoutMetricsLazyRoute
  '/_auth/credit-applications/$submissionId': typeof AuthCreditApplicationsSubmissionIdLazyRoute
  '/_auth/credit-policies/$policyId': typeof AuthCreditPoliciesPolicyIdLazyRoute
  '/_auth/super-admin/agents': typeof AuthSuperAdminAgentsLazyRoute
  '/_auth/super-admin/api-keys': typeof AuthSuperAdminApiKeysLazyRoute
  '/_auth/super-admin/billing': typeof AuthSuperAdminBillingLazyRoute
  '/_auth/super-admin/groups': typeof AuthSuperAdminGroupsLazyRoute
  '/_auth/super-admin/import': typeof AuthSuperAdminImportLazyRoute
  '/_auth/super-admin/import-configurations': typeof AuthSuperAdminImportConfigurationsLazyRoute
  '/_auth/super-admin/settings': typeof AuthSuperAdminSettingsLazyRoute
  '/_auth/_layout/': typeof AuthLayoutIndexLazyRoute
  '/_auth/credit-applications/': typeof AuthCreditApplicationsIndexLazyRoute
  '/_auth/credit-policies/': typeof AuthCreditPoliciesIndexLazyRoute
  '/_auth/search/': typeof AuthSearchIndexLazyRoute
  '/_auth/super-admin/': typeof AuthSuperAdminIndexLazyRoute
  '/_auth/accounts/_layout/$accountId': typeof AuthAccountsLayoutAccountIdLazyRouteWithChildren
  '/_auth/search/$query/': typeof AuthSearchQueryIndexLazyRoute
  '/_auth/accounts/_layout/$accountId/applications': typeof AuthAccountsLayoutAccountIdApplicationsLazyRoute
  '/_auth/accounts/_layout/$accountId/audit-log': typeof AuthAccountsLayoutAccountIdAuditLogLazyRoute
  '/_auth/accounts/_layout/$accountId/benchmarks': typeof AuthAccountsLayoutAccountIdBenchmarksLazyRoute
  '/_auth/accounts/_layout/$accountId/details': typeof AuthAccountsLayoutAccountIdDetailsLazyRoute
  '/_auth/accounts/_layout/$accountId/financials': typeof AuthAccountsLayoutAccountIdFinancialsLazyRouteWithChildren
  '/_auth/accounts/_layout/$accountId/notifications': typeof AuthAccountsLayoutAccountIdNotificationsLazyRoute
  '/_auth/accounts/_layout/$accountId/people': typeof AuthAccountsLayoutAccountIdPeopleLazyRoute
  '/_auth/accounts/_layout/$accountId/research-agents': typeof AuthAccountsLayoutAccountIdResearchAgentsLazyRoute
  '/_auth/accounts/_layout/$accountId/': typeof AuthAccountsLayoutAccountIdIndexLazyRoute
  '/_auth/accounts/_layout/$accountId/financials/': typeof AuthAccountsLayoutAccountIdFinancialsIndexLazyRoute
  '/_auth/accounts/_layout/$accountId/financials/statement-edit/$statementId': typeof AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/test-error'
    | '/super-admin'
    | '/benchmarks'
    | '/metrics'
    | '/credit-applications/$submissionId'
    | '/credit-policies/$policyId'
    | '/super-admin/agents'
    | '/super-admin/api-keys'
    | '/super-admin/billing'
    | '/super-admin/groups'
    | '/super-admin/import'
    | '/super-admin/import-configurations'
    | '/super-admin/settings'
    | '/'
    | '/credit-applications'
    | '/credit-policies'
    | '/search'
    | '/super-admin/'
    | '/accounts/$accountId'
    | '/search/$query'
    | '/accounts/$accountId/applications'
    | '/accounts/$accountId/audit-log'
    | '/accounts/$accountId/benchmarks'
    | '/accounts/$accountId/details'
    | '/accounts/$accountId/financials'
    | '/accounts/$accountId/notifications'
    | '/accounts/$accountId/people'
    | '/accounts/$accountId/research-agents'
    | '/accounts/$accountId/'
    | '/accounts/$accountId/financials/'
    | '/accounts/$accountId/financials/statement-edit/$statementId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/test-error'
    | '/benchmarks'
    | '/metrics'
    | '/credit-applications/$submissionId'
    | '/credit-policies/$policyId'
    | '/super-admin/agents'
    | '/super-admin/api-keys'
    | '/super-admin/billing'
    | '/super-admin/groups'
    | '/super-admin/import'
    | '/super-admin/import-configurations'
    | '/super-admin/settings'
    | '/'
    | '/credit-applications'
    | '/credit-policies'
    | '/search'
    | '/super-admin'
    | '/search/$query'
    | '/accounts/$accountId/applications'
    | '/accounts/$accountId/audit-log'
    | '/accounts/$accountId/benchmarks'
    | '/accounts/$accountId/details'
    | '/accounts/$accountId/notifications'
    | '/accounts/$accountId/people'
    | '/accounts/$accountId/research-agents'
    | '/accounts/$accountId'
    | '/accounts/$accountId/financials'
    | '/accounts/$accountId/financials/statement-edit/$statementId'
  id:
    | '__root__'
    | '/_auth'
    | '/test-error'
    | '/_auth/super-admin'
    | '/_auth/_layout'
    | '/_auth/_layout/benchmarks'
    | '/_auth/_layout/metrics'
    | '/_auth/credit-applications/$submissionId'
    | '/_auth/credit-policies/$policyId'
    | '/_auth/super-admin/agents'
    | '/_auth/super-admin/api-keys'
    | '/_auth/super-admin/billing'
    | '/_auth/super-admin/groups'
    | '/_auth/super-admin/import'
    | '/_auth/super-admin/import-configurations'
    | '/_auth/super-admin/settings'
    | '/_auth/_layout/'
    | '/_auth/credit-applications/'
    | '/_auth/credit-policies/'
    | '/_auth/search/'
    | '/_auth/super-admin/'
    | '/_auth/accounts/_layout/$accountId'
    | '/_auth/search/$query/'
    | '/_auth/accounts/_layout/$accountId/applications'
    | '/_auth/accounts/_layout/$accountId/audit-log'
    | '/_auth/accounts/_layout/$accountId/benchmarks'
    | '/_auth/accounts/_layout/$accountId/details'
    | '/_auth/accounts/_layout/$accountId/financials'
    | '/_auth/accounts/_layout/$accountId/notifications'
    | '/_auth/accounts/_layout/$accountId/people'
    | '/_auth/accounts/_layout/$accountId/research-agents'
    | '/_auth/accounts/_layout/$accountId/'
    | '/_auth/accounts/_layout/$accountId/financials/'
    | '/_auth/accounts/_layout/$accountId/financials/statement-edit/$statementId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  TestErrorLazyRoute: typeof TestErrorLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test-error': {
      id: '/test-error'
      path: '/test-error'
      fullPath: '/test-error'
      preLoaderRoute: typeof TestErrorLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/_layout': {
      id: '/_auth/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthLayoutLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/super-admin': {
      id: '/_auth/super-admin'
      path: '/super-admin'
      fullPath: '/super-admin'
      preLoaderRoute: typeof AuthSuperAdminRouteLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/super-admin/': {
      id: '/_auth/super-admin/'
      path: '/'
      fullPath: '/super-admin/'
      preLoaderRoute: typeof AuthSuperAdminIndexLazyRouteImport
      parentRoute: typeof AuthSuperAdminRouteLazyRoute
    }
    '/_auth/search/': {
      id: '/_auth/search/'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthSearchIndexLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/credit-policies/': {
      id: '/_auth/credit-policies/'
      path: '/credit-policies'
      fullPath: '/credit-policies'
      preLoaderRoute: typeof AuthCreditPoliciesIndexLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/credit-applications/': {
      id: '/_auth/credit-applications/'
      path: '/credit-applications'
      fullPath: '/credit-applications'
      preLoaderRoute: typeof AuthCreditApplicationsIndexLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_layout/': {
      id: '/_auth/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthLayoutIndexLazyRouteImport
      parentRoute: typeof AuthLayoutLazyRoute
    }
    '/_auth/super-admin/settings': {
      id: '/_auth/super-admin/settings'
      path: '/settings'
      fullPath: '/super-admin/settings'
      preLoaderRoute: typeof AuthSuperAdminSettingsLazyRouteImport
      parentRoute: typeof AuthSuperAdminRouteLazyRoute
    }
    '/_auth/super-admin/import-configurations': {
      id: '/_auth/super-admin/import-configurations'
      path: '/import-configurations'
      fullPath: '/super-admin/import-configurations'
      preLoaderRoute: typeof AuthSuperAdminImportConfigurationsLazyRouteImport
      parentRoute: typeof AuthSuperAdminRouteLazyRoute
    }
    '/_auth/super-admin/import': {
      id: '/_auth/super-admin/import'
      path: '/import'
      fullPath: '/super-admin/import'
      preLoaderRoute: typeof AuthSuperAdminImportLazyRouteImport
      parentRoute: typeof AuthSuperAdminRouteLazyRoute
    }
    '/_auth/super-admin/groups': {
      id: '/_auth/super-admin/groups'
      path: '/groups'
      fullPath: '/super-admin/groups'
      preLoaderRoute: typeof AuthSuperAdminGroupsLazyRouteImport
      parentRoute: typeof AuthSuperAdminRouteLazyRoute
    }
    '/_auth/super-admin/billing': {
      id: '/_auth/super-admin/billing'
      path: '/billing'
      fullPath: '/super-admin/billing'
      preLoaderRoute: typeof AuthSuperAdminBillingLazyRouteImport
      parentRoute: typeof AuthSuperAdminRouteLazyRoute
    }
    '/_auth/super-admin/api-keys': {
      id: '/_auth/super-admin/api-keys'
      path: '/api-keys'
      fullPath: '/super-admin/api-keys'
      preLoaderRoute: typeof AuthSuperAdminApiKeysLazyRouteImport
      parentRoute: typeof AuthSuperAdminRouteLazyRoute
    }
    '/_auth/super-admin/agents': {
      id: '/_auth/super-admin/agents'
      path: '/agents'
      fullPath: '/super-admin/agents'
      preLoaderRoute: typeof AuthSuperAdminAgentsLazyRouteImport
      parentRoute: typeof AuthSuperAdminRouteLazyRoute
    }
    '/_auth/credit-policies/$policyId': {
      id: '/_auth/credit-policies/$policyId'
      path: '/credit-policies/$policyId'
      fullPath: '/credit-policies/$policyId'
      preLoaderRoute: typeof AuthCreditPoliciesPolicyIdLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/credit-applications/$submissionId': {
      id: '/_auth/credit-applications/$submissionId'
      path: '/credit-applications/$submissionId'
      fullPath: '/credit-applications/$submissionId'
      preLoaderRoute: typeof AuthCreditApplicationsSubmissionIdLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_layout/metrics': {
      id: '/_auth/_layout/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof AuthLayoutMetricsLazyRouteImport
      parentRoute: typeof AuthLayoutLazyRoute
    }
    '/_auth/_layout/benchmarks': {
      id: '/_auth/_layout/benchmarks'
      path: '/benchmarks'
      fullPath: '/benchmarks'
      preLoaderRoute: typeof AuthLayoutBenchmarksLazyRouteImport
      parentRoute: typeof AuthLayoutLazyRoute
    }
    '/_auth/search/$query/': {
      id: '/_auth/search/$query/'
      path: '/search/$query'
      fullPath: '/search/$query'
      preLoaderRoute: typeof AuthSearchQueryIndexLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accounts/_layout/$accountId': {
      id: '/_auth/accounts/_layout/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/accounts/$accountId'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/accounts/_layout/$accountId/': {
      id: '/_auth/accounts/_layout/$accountId/'
      path: '/'
      fullPath: '/accounts/$accountId/'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdIndexLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdLazyRoute
    }
    '/_auth/accounts/_layout/$accountId/research-agents': {
      id: '/_auth/accounts/_layout/$accountId/research-agents'
      path: '/research-agents'
      fullPath: '/accounts/$accountId/research-agents'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdResearchAgentsLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdLazyRoute
    }
    '/_auth/accounts/_layout/$accountId/people': {
      id: '/_auth/accounts/_layout/$accountId/people'
      path: '/people'
      fullPath: '/accounts/$accountId/people'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdPeopleLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdLazyRoute
    }
    '/_auth/accounts/_layout/$accountId/notifications': {
      id: '/_auth/accounts/_layout/$accountId/notifications'
      path: '/notifications'
      fullPath: '/accounts/$accountId/notifications'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdNotificationsLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdLazyRoute
    }
    '/_auth/accounts/_layout/$accountId/financials': {
      id: '/_auth/accounts/_layout/$accountId/financials'
      path: '/financials'
      fullPath: '/accounts/$accountId/financials'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdFinancialsLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdLazyRoute
    }
    '/_auth/accounts/_layout/$accountId/details': {
      id: '/_auth/accounts/_layout/$accountId/details'
      path: '/details'
      fullPath: '/accounts/$accountId/details'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdDetailsLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdLazyRoute
    }
    '/_auth/accounts/_layout/$accountId/benchmarks': {
      id: '/_auth/accounts/_layout/$accountId/benchmarks'
      path: '/benchmarks'
      fullPath: '/accounts/$accountId/benchmarks'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdBenchmarksLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdLazyRoute
    }
    '/_auth/accounts/_layout/$accountId/audit-log': {
      id: '/_auth/accounts/_layout/$accountId/audit-log'
      path: '/audit-log'
      fullPath: '/accounts/$accountId/audit-log'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdAuditLogLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdLazyRoute
    }
    '/_auth/accounts/_layout/$accountId/applications': {
      id: '/_auth/accounts/_layout/$accountId/applications'
      path: '/applications'
      fullPath: '/accounts/$accountId/applications'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdApplicationsLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdLazyRoute
    }
    '/_auth/accounts/_layout/$accountId/financials/': {
      id: '/_auth/accounts/_layout/$accountId/financials/'
      path: '/'
      fullPath: '/accounts/$accountId/financials/'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdFinancialsIndexLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdFinancialsLazyRoute
    }
    '/_auth/accounts/_layout/$accountId/financials/statement-edit/$statementId': {
      id: '/_auth/accounts/_layout/$accountId/financials/statement-edit/$statementId'
      path: '/statement-edit/$statementId'
      fullPath: '/accounts/$accountId/financials/statement-edit/$statementId'
      preLoaderRoute: typeof AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRouteImport
      parentRoute: typeof AuthAccountsLayoutAccountIdFinancialsLazyRoute
    }
  }
}

interface AuthSuperAdminRouteLazyRouteChildren {
  AuthSuperAdminAgentsLazyRoute: typeof AuthSuperAdminAgentsLazyRoute
  AuthSuperAdminApiKeysLazyRoute: typeof AuthSuperAdminApiKeysLazyRoute
  AuthSuperAdminBillingLazyRoute: typeof AuthSuperAdminBillingLazyRoute
  AuthSuperAdminGroupsLazyRoute: typeof AuthSuperAdminGroupsLazyRoute
  AuthSuperAdminImportLazyRoute: typeof AuthSuperAdminImportLazyRoute
  AuthSuperAdminImportConfigurationsLazyRoute: typeof AuthSuperAdminImportConfigurationsLazyRoute
  AuthSuperAdminSettingsLazyRoute: typeof AuthSuperAdminSettingsLazyRoute
  AuthSuperAdminIndexLazyRoute: typeof AuthSuperAdminIndexLazyRoute
}

const AuthSuperAdminRouteLazyRouteChildren: AuthSuperAdminRouteLazyRouteChildren =
  {
    AuthSuperAdminAgentsLazyRoute: AuthSuperAdminAgentsLazyRoute,
    AuthSuperAdminApiKeysLazyRoute: AuthSuperAdminApiKeysLazyRoute,
    AuthSuperAdminBillingLazyRoute: AuthSuperAdminBillingLazyRoute,
    AuthSuperAdminGroupsLazyRoute: AuthSuperAdminGroupsLazyRoute,
    AuthSuperAdminImportLazyRoute: AuthSuperAdminImportLazyRoute,
    AuthSuperAdminImportConfigurationsLazyRoute:
      AuthSuperAdminImportConfigurationsLazyRoute,
    AuthSuperAdminSettingsLazyRoute: AuthSuperAdminSettingsLazyRoute,
    AuthSuperAdminIndexLazyRoute: AuthSuperAdminIndexLazyRoute,
  }

const AuthSuperAdminRouteLazyRouteWithChildren =
  AuthSuperAdminRouteLazyRoute._addFileChildren(
    AuthSuperAdminRouteLazyRouteChildren,
  )

interface AuthLayoutLazyRouteChildren {
  AuthLayoutBenchmarksLazyRoute: typeof AuthLayoutBenchmarksLazyRoute
  AuthLayoutMetricsLazyRoute: typeof AuthLayoutMetricsLazyRoute
  AuthLayoutIndexLazyRoute: typeof AuthLayoutIndexLazyRoute
}

const AuthLayoutLazyRouteChildren: AuthLayoutLazyRouteChildren = {
  AuthLayoutBenchmarksLazyRoute: AuthLayoutBenchmarksLazyRoute,
  AuthLayoutMetricsLazyRoute: AuthLayoutMetricsLazyRoute,
  AuthLayoutIndexLazyRoute: AuthLayoutIndexLazyRoute,
}

const AuthLayoutLazyRouteWithChildren = AuthLayoutLazyRoute._addFileChildren(
  AuthLayoutLazyRouteChildren,
)

interface AuthAccountsLayoutAccountIdFinancialsLazyRouteChildren {
  AuthAccountsLayoutAccountIdFinancialsIndexLazyRoute: typeof AuthAccountsLayoutAccountIdFinancialsIndexLazyRoute
  AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRoute: typeof AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRoute
}

const AuthAccountsLayoutAccountIdFinancialsLazyRouteChildren: AuthAccountsLayoutAccountIdFinancialsLazyRouteChildren =
  {
    AuthAccountsLayoutAccountIdFinancialsIndexLazyRoute:
      AuthAccountsLayoutAccountIdFinancialsIndexLazyRoute,
    AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRoute:
      AuthAccountsLayoutAccountIdFinancialsStatementEditStatementIdLazyRoute,
  }

const AuthAccountsLayoutAccountIdFinancialsLazyRouteWithChildren =
  AuthAccountsLayoutAccountIdFinancialsLazyRoute._addFileChildren(
    AuthAccountsLayoutAccountIdFinancialsLazyRouteChildren,
  )

interface AuthAccountsLayoutAccountIdLazyRouteChildren {
  AuthAccountsLayoutAccountIdApplicationsLazyRoute: typeof AuthAccountsLayoutAccountIdApplicationsLazyRoute
  AuthAccountsLayoutAccountIdAuditLogLazyRoute: typeof AuthAccountsLayoutAccountIdAuditLogLazyRoute
  AuthAccountsLayoutAccountIdBenchmarksLazyRoute: typeof AuthAccountsLayoutAccountIdBenchmarksLazyRoute
  AuthAccountsLayoutAccountIdDetailsLazyRoute: typeof AuthAccountsLayoutAccountIdDetailsLazyRoute
  AuthAccountsLayoutAccountIdFinancialsLazyRoute: typeof AuthAccountsLayoutAccountIdFinancialsLazyRouteWithChildren
  AuthAccountsLayoutAccountIdNotificationsLazyRoute: typeof AuthAccountsLayoutAccountIdNotificationsLazyRoute
  AuthAccountsLayoutAccountIdPeopleLazyRoute: typeof AuthAccountsLayoutAccountIdPeopleLazyRoute
  AuthAccountsLayoutAccountIdResearchAgentsLazyRoute: typeof AuthAccountsLayoutAccountIdResearchAgentsLazyRoute
  AuthAccountsLayoutAccountIdIndexLazyRoute: typeof AuthAccountsLayoutAccountIdIndexLazyRoute
}

const AuthAccountsLayoutAccountIdLazyRouteChildren: AuthAccountsLayoutAccountIdLazyRouteChildren =
  {
    AuthAccountsLayoutAccountIdApplicationsLazyRoute:
      AuthAccountsLayoutAccountIdApplicationsLazyRoute,
    AuthAccountsLayoutAccountIdAuditLogLazyRoute:
      AuthAccountsLayoutAccountIdAuditLogLazyRoute,
    AuthAccountsLayoutAccountIdBenchmarksLazyRoute:
      AuthAccountsLayoutAccountIdBenchmarksLazyRoute,
    AuthAccountsLayoutAccountIdDetailsLazyRoute:
      AuthAccountsLayoutAccountIdDetailsLazyRoute,
    AuthAccountsLayoutAccountIdFinancialsLazyRoute:
      AuthAccountsLayoutAccountIdFinancialsLazyRouteWithChildren,
    AuthAccountsLayoutAccountIdNotificationsLazyRoute:
      AuthAccountsLayoutAccountIdNotificationsLazyRoute,
    AuthAccountsLayoutAccountIdPeopleLazyRoute:
      AuthAccountsLayoutAccountIdPeopleLazyRoute,
    AuthAccountsLayoutAccountIdResearchAgentsLazyRoute:
      AuthAccountsLayoutAccountIdResearchAgentsLazyRoute,
    AuthAccountsLayoutAccountIdIndexLazyRoute:
      AuthAccountsLayoutAccountIdIndexLazyRoute,
  }

const AuthAccountsLayoutAccountIdLazyRouteWithChildren =
  AuthAccountsLayoutAccountIdLazyRoute._addFileChildren(
    AuthAccountsLayoutAccountIdLazyRouteChildren,
  )

interface AuthRouteChildren {
  AuthSuperAdminRouteLazyRoute: typeof AuthSuperAdminRouteLazyRouteWithChildren
  AuthLayoutLazyRoute: typeof AuthLayoutLazyRouteWithChildren
  AuthCreditApplicationsSubmissionIdLazyRoute: typeof AuthCreditApplicationsSubmissionIdLazyRoute
  AuthCreditPoliciesPolicyIdLazyRoute: typeof AuthCreditPoliciesPolicyIdLazyRoute
  AuthCreditApplicationsIndexLazyRoute: typeof AuthCreditApplicationsIndexLazyRoute
  AuthCreditPoliciesIndexLazyRoute: typeof AuthCreditPoliciesIndexLazyRoute
  AuthSearchIndexLazyRoute: typeof AuthSearchIndexLazyRoute
  AuthAccountsLayoutAccountIdLazyRoute: typeof AuthAccountsLayoutAccountIdLazyRouteWithChildren
  AuthSearchQueryIndexLazyRoute: typeof AuthSearchQueryIndexLazyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSuperAdminRouteLazyRoute: AuthSuperAdminRouteLazyRouteWithChildren,
  AuthLayoutLazyRoute: AuthLayoutLazyRouteWithChildren,
  AuthCreditApplicationsSubmissionIdLazyRoute:
    AuthCreditApplicationsSubmissionIdLazyRoute,
  AuthCreditPoliciesPolicyIdLazyRoute: AuthCreditPoliciesPolicyIdLazyRoute,
  AuthCreditApplicationsIndexLazyRoute: AuthCreditApplicationsIndexLazyRoute,
  AuthCreditPoliciesIndexLazyRoute: AuthCreditPoliciesIndexLazyRoute,
  AuthSearchIndexLazyRoute: AuthSearchIndexLazyRoute,
  AuthAccountsLayoutAccountIdLazyRoute:
    AuthAccountsLayoutAccountIdLazyRouteWithChildren,
  AuthSearchQueryIndexLazyRoute: AuthSearchQueryIndexLazyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  TestErrorLazyRoute: TestErrorLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
